<template>
<div>
  <el-form style="margin: 20px 40px 0 0" :model="cardForm" :rules="cardRules" ref="cardForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="老年卡号" prop="elderly_card_id">
      <el-input v-model="cardForm.elderly_card_id" placeholder="请输入老年卡号"></el-input>
    </el-form-item>
    <el-form-item label="有效期至" prop="validity_date">
      <el-date-picker v-fixZoom style="width: 100%" v-model="cardForm.validity_date"
                      type="date" value-format="yyyy-MM-dd" placeholder="xxxx-xx-xx">
      </el-date-picker>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 30px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditCard('cardForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {createelderlycardinfo, updateelderlycardinfo} from '../../../api/yanglaoyuan'

export default {
  name: 'oldCard',
  model: {
    prop: 'addEditShow',
    event: 'change'
  },
  props: {
    cardRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isAdd: true,
      cardForm: {
        id: 0,
        ep_id: 0,
        elderly_card_id: '',
        card_status_code: '',
        elderly_id: '',
        elderly_name: '',
        name_pinyin: '',
        identity_type: '',
        identity_number: '',
        person_status_code: '',
        card_identification_code: '',
        card_type_code: '',
        standard_version: '',
        initialization_organization: '',
        issue_date: '',
        validity_date: '',
        photo_info: '',
        photo_collection_date: '',
        fingerprint_info: '',
        fingerprint_collection_date: '',
        card_usage_datetime: '',
        card_usage_code: '',
        card_service_type_code: '',
        card_usage_amount: 0
      },
      cardRules: {
        elderly_card_id: [{ required: true, message: '请输入老年卡号', trigger: 'blur' }],
        validity_date: [{ required: true, message: '请选择有效期', trigger: 'change' }]
      },
      cardLevel: [
        {id: 0, name: '普通卡'},
        {id: 1, name: '会员'},
        {id: 1, name: '高级会员'}
      ]
    }
  },
  created () {
    console.log(this.cardRow.oldPersonRow)
    this.isAdd = this.cardRow.isAdd
    this.getStartData()
  },
  methods: {
    getStartData () {
      this.cardForm.ep_id = this.cardRow.oldPersonRow.id
      this.cardForm.elderly_id = this.cardRow.oldPersonRow.elderly_id
      this.cardForm.elderly_name = this.cardRow.oldPersonRow.elderly_name
      this.cardForm.name_pinyin = this.cardRow.oldPersonRow.name_pinyin
      this.cardForm.identity_type = this.cardRow.oldPersonRow.id_type
      this.cardForm.identity_number = this.cardRow.oldPersonRow.id_number
      if (!this.isAdd) {
        this.cardForm.id = this.cardRow.row.id
        this.cardForm.elderly_card_id = this.cardRow.row.elderly_card_id
        this.cardForm.card_status_code = this.cardRow.row.card_status_code
        this.cardForm.person_status_code = this.cardRow.row.person_status_code
        this.cardForm.card_identification_code = this.cardRow.row.card_identification_code
        this.cardForm.card_type_code = this.cardRow.row.card_type_code
        this.cardForm.standard_version = this.cardRow.row.standard_version
        this.cardForm.initialization_organization = this.cardRow.row.initialization_organization
        this.cardForm.issue_date = this.cardRow.row.issue_date
        this.cardForm.validity_date = this.cardRow.row.validity_date
        this.cardForm.photo_info = this.cardRow.row.photo_info
        this.cardForm.photo_collection_date = this.cardRow.row.photo_collection_date
        this.cardForm.fingerprint_info = this.cardRow.row.fingerprint_info
        this.cardForm.fingerprint_collection_date = this.cardRow.row.fingerprint_collection_date
        this.cardForm.card_usage_datetime = this.cardRow.row.card_usage_datetime
        this.cardForm.card_usage_code = this.cardRow.row.card_usage_code
        this.cardForm.card_service_type_code = this.cardRow.row.card_service_type_code
        this.cardForm.card_usage_amount = this.cardRow.row.card_usage_amount
      }
    },
    closeAddEdit () {
      this.$emit('change', false)
    },
    submitAddEditCard (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            createelderlycardinfo(this.cardForm).then(res => {
              this.$notify({title: '成功', message: '成功添加老年卡', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          } else {
            updateelderlycardinfo(this.cardForm).then(res => {
              this.$notify({title: '成功', message: '成功编辑老年卡', type: 'success', duration: 2000})
              this.$emit('updateTable')
              this.$emit('change', false)
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/oldCard.vue